import React, { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useFormik } from 'formik'

import StepForm from '../../../../../../../features/components/Forms/StepForm'
import NameStep from '../../../../ReusableSteps/NameStep'
import LinkStep from '../../../../ReusableSteps/LinkStep'
import VideoAdsStep from './Steps/VideoAdsStep'
import HeadlinesStep from '../../../../ReusableSteps/HeadlinesStep'
import DescriptionsStep from '../../../../ReusableSteps/DescriptionsStep'
import CallToActionStep from '../../../../ReusableSteps/CallToActionStep'
import LongHeadlinesStep from './Steps/LongHeadlinesStep'
import BusinessNameStep from '../../../../ReusableSteps/BusinessNameStep.js'
import LandscapeImageStep from '../../../../ReusableSteps/LandscapeImageStep'
import SquareImageStep from '../../../../ReusableSteps/SquareImageStep'
import PortraitImageStep from './Steps/PortraitImageStep'
import SquareLogoStep from '../../../../ReusableSteps/SquareLogoStep'
import LandscapeLogoStep from '../../../../ReusableSteps/LandscapeLogoStep'
import StatusStep from '../../../../ReusableSteps/StatusStep'

import useGoogleAssetGroupCreate from './hooks/useGoogleAssetGroupCreate'
import { usePurifiedFormik } from '../../../../../../../hooks/formHooks/usePurifiedFormik'

import { campaignLoadingSelector } from '../../../../../../../modules/selectors/campaigns'
import { assetGroupCreateDataSelector } from '../../../../../../../modules/selectors/assets'
import { selectedPartnershipSelector } from '../../../../../../../modules/selectors/partnerships'

import { ASSET_GROUP_GOOGLE_ADS_CREATE } from '../../../../../../../constants/forms'
import { getInitialValues } from './fields'
import { validationSchema } from '../../../validations'

const GoogleAssetGroupCreateForm = ({ onSuccessSubmit, formProgressItems, isInternalAssetGroupCreation }) => {
  const selectedPartnership = useSelector(selectedPartnershipSelector)
  const isCampaignLoading = useSelector(campaignLoadingSelector)
  const assetGroupCreatedData = useSelector(assetGroupCreateDataSelector)

  const { partner_name: partnerName } = selectedPartnership

  const { onSubmit, onClearSubmit, isLoadingSelector, errorSelector, successSubmit } = useGoogleAssetGroupCreate({
    isInternalAssetGroupCreation
  })

  const initialValues = useMemo(
    () => getInitialValues(partnerName, isInternalAssetGroupCreation),
    [isInternalAssetGroupCreation, partnerName]
  )

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  })

  const purifiedFormik = usePurifiedFormik(formik)

  const steps = useMemo(
    () => [
      {
        component: <BusinessNameStep />,
        show: true
      },
      {
        component: <LinkStep />,
        show: true
      },
      {
        component: <HeadlinesStep />,
        show: true
      },
      {
        component: <DescriptionsStep />,
        show: true
      },
      {
        component: <LongHeadlinesStep />,
        show: true
      },
      {
        component: <LandscapeImageStep />,
        show: true
      },
      {
        component: <SquareImageStep />,
        show: true
      },
      {
        component: <PortraitImageStep />,
        show: true
      },
      {
        component: <SquareLogoStep />,
        show: true
      },
      {
        component: <LandscapeLogoStep />,
        show: true
      },
      {
        component: <VideoAdsStep />,
        show: true
      },
      {
        component: <CallToActionStep />,
        show: true
      },
      {
        component: <NameStep />,
        show: true
      },
      {
        component: <StatusStep />,
        show: true
      }
    ],
    []
  )

  const successSubmitHandler = useCallback(() => {
    onSuccessSubmit(assetGroupCreatedData)
  }, [assetGroupCreatedData, onSuccessSubmit])

  return (
    <StepForm
      steps={steps}
      formik={purifiedFormik}
      formName={ASSET_GROUP_GOOGLE_ADS_CREATE}
      isLoadingSelector={isLoadingSelector}
      errorSelector={errorSelector}
      successSubmit={successSubmit}
      isInitialDataLoading={isCampaignLoading}
      formProgressItems={formProgressItems}
      clearSubmitHandler={onClearSubmit}
      onSuccessSubmit={successSubmitHandler}
    />
  )
}

export default GoogleAssetGroupCreateForm
